/**
 * Global fallback for broken <img> elements.
 *
 * Photos uploaded through Uploadcare (ucarecdn.com) stopped being served in
 * September 2026 (account/CDN issue). Rather than showing the browser's broken
 * image icon and the alt text on hundreds of listings and profiles, swap any
 * image that fails to load for a neutral placeholder. Works for images added
 * later too, because the error event is caught at the document level.
 */
export const IMAGE_PLACEHOLDER = '/image-placeholder.svg';

const HANDLED = 'data-fallback-applied';

export function installImageFallback(): () => void {
  const onError = (event: Event) => {
    const target = event.target as HTMLElement | null;
    if (!target || target.tagName !== 'IMG') return;
    const img = target as HTMLImageElement;
    if (img.getAttribute(HANDLED) || img.src.endsWith(IMAGE_PLACEHOLDER)) return;
    img.setAttribute(HANDLED, 'true');
    img.removeAttribute('srcset');
    img.src = IMAGE_PLACEHOLDER;
  };
  // Resource errors do not bubble, so listen in the capture phase.
  document.addEventListener('error', onError, true);
  return () => document.removeEventListener('error', onError, true);
}
